angular.module('impactx.sapconfig').controller('TaxCodeCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'ToastService',
    'TranslationService',
    'BackService',
    'ToolbarService',
    TaxCodeCtrl]);

function TaxCodeCtrl($scope, dataGen, $routeParams, ToastService, TranslationService, BackService, ToolbarService) {
    var self = this;

    dataGen.getData($scope, {sapConfigId: $routeParams.sapConfigId, id: $routeParams.id}, '/sapconfiguration/taxcode/view').then(function () {
        defineButtons();
    });

    self.save = function () {
        return dataGen.postAsForm($scope, {taxCodeData: $scope.data}, '/sapconfiguration/taxcode/save').then(function () {
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
            BackService.back();
        });
    };

    self.updateTaxData = function () {
        if ($scope.data.taxCode.region.selected) {
            var tmpScope = {};
            dataGen.getData(tmpScope, {regionId: $scope.data.taxCode.region.selected.id}, '/sapconfiguration/taxcode/taxes').then(function () {
                $scope.data.taxCode.taxes.entries = [];
                $scope.data.taxCode.taxes.selected = null;
                angular.copy(tmpScope.data.entries, $scope.data.taxCode.taxes.entries);
            });
        }
    };

    self.updateTaxEventData = function () {
        if ($scope.data.taxCode.region.selected && $scope.data.taxCode.taxes.selected) {
            var tmpScope = {};
            dataGen.getData(tmpScope, {regionId: $scope.data.taxCode.region.selected.id, rate: $scope.data.taxCode.taxes.selected.id}, '/sapconfiguration/taxcode/taxevents').then(function () {
                $scope.data.taxCode.taxEvent.entries = [];
                $scope.data.taxCode.taxEvent.selected = null;
                angular.copy(tmpScope.data.entries, $scope.data.taxCode.taxEvent.entries);
            });
        }
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: self.save,
                type: 'validation',
                params: {
                    form: $scope.dialogData
                }
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }
}